import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  joinMeeting
} from '../../services/api';

const BBBJoinButton = ({ 
  meetingId, 
  userName = 'Participant', 
  role = 'viewer',
}) => {

  const handleJoinMeeting = async () => {
    try {
      const joinUrl = await joinMeeting(meetingId, userName, role);
      if (joinUrl) {
        window.open(joinUrl, '_blank', 'noopener,noreferrer');
      } else {
        console.error('No join URL received from server');
        alert('Unable to join meeting. Please try again.');
      }
    } catch (error) {
      console.error('Unable to join meeting:', error);
      alert(`Unable to join meeting: ${error.message || 'Unknown error'}`);
    }
  };

  return (
    <button
      className="btn btn-primary position-fixed bottom-0 m-4 rounded-circle shadow"
      style={{ 
        width: '56px', 
        height: '56px', 
        zIndex: 1040, 
        right: 'calc(1.5rem + 56px + 1rem)' // Position to the left of ChatWidget button (1.5rem + button width + spacing)
      }}
      onClick={handleJoinMeeting}
      aria-label={`Join video conference`}
    >
      <svg
        aria-hidden="true"
        viewBox="0 0 24 24"
        width="24"
        height="24"
        fill="currentColor"
      >
        <path d="M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.999-.9 1.999-2L23 6c0-1.1-.9-2-2-2zm0 14H3V6h18v12z"/>
        <path d="M9 13h6v-2H9v2zm0 4h6v-2H9v2z"/>        
      </svg>
    </button>
  );
};

//        aria-label={`Join ${meetingId} as ${role}`}

BBBJoinButton.propTypes = {
  meetingId: PropTypes.string.isRequired,
  userName: PropTypes.string,
  role: PropTypes.oneOf(['moderator', 'viewer']),
  className: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'secondary', 'outline'])
};

export default BBBJoinButton;